import {
  Datagrid,
  List,
  ReferenceField,
  TextField
} from 'react-admin';
import ListPagination from '../../components/ListPagination';

const list = props => (
  <List {...props}
    perPage={25}
    pagination={<ListPagination />}
    exporter={false}
    title="Permissões">
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" label="Nome" />
      <TextField source="label" label="Descrição" />
      <ReferenceField source="groupId" label="Grupo" reference="permission-groups">
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
  </List>
);

export default list;